import script from "./help.vue?vue&type=script&setup=true&lang=js"
export * from "./help.vue?vue&type=script&setup=true&lang=js"

import "./help.vue?vue&type=style&index=0&id=83224272&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83224272"]])

export default __exports__